import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IProfile } from '../interfaces/profile';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private profile: IProfile;

  constructor() { }

  getProfile(): IProfile {

    switch (environment.city) {
      case "botucatu":
        this.profile = {
          description: [
            "Sou mineira, nascida na cidade de Poços de Caldas, cresci e me formei em Alfenas, ambas cidades do sul de Minas. Me mudei para Botucatu em em 2019 e me encantei pela cidade dos bons ares.",
            "Sou especialista em Clínica Médica pelo Hospital Universitário Alzira Vellano e Especialista em Pneumologia pela Unesp - Faculdade de Medicina de Botucatu.",
            "Atualmente realizo mais uma especialização, um fellowshipp em Medicina do sono pela Unesp - Faculdade de Medicina de Botucatu. Saiba mais sobre minha formação, publicações e trabalhos apresentados acessando meu curriculum."
          ],
          crm: "CRM SP 203777",
          address: {
            city: "Botucatu",
            rawCity: "botucatu",
            clinic: "Clínica Santa Maria",
            street: "Rua Major Leônidas Cardoso",
            number: "853",
            complement: "",
            district: "Centro",
            state: "SP",
            zipCode: "18602-010",
            phones: [
              { rawNumber: "+551438145036", formatNumber: "(14) 3814-5036" },
              { rawNumber: "+5514997372257", formatNumber: "(14) 9 9737-2257" },
              { rawNumber: "+5535999858799", formatNumber: "(35) 9 9985-8799" }
            ],
            lat: -22.8879804,
            lng: -48.4495996,
            zoom: 15,
            whatsAppNumber: "5535999858799"
          }
        };
        break;

      case "pocos-de-caldas":
        this.profile = {
          description: [
            "Sou mineira, nascida na cidade de Poços de Caldas, cresci e me formei em Alfenas, ambas cidades do sul de Minas.",
            "Sou especialista em Clínica Médica pelo Hospital Universitário Alzira Vellano e Especialista em Pneumologia pela Unesp - Faculdade de Medicina de Botucatu.",
            "Atualmente realizo mais uma especialização, um fellowshipp em Medicina do sono pela Unesp - Faculdade de Medicina de Botucatu. Saiba mais sobre minha formação, publicações e trabalhos apresentados acessando meu curriculum."
          ],
          crm: "CRM MG 68278",
          address: {
            city: "Poços de Caldas",
            rawCity: "pocos-de-caldas",
            clinic: "Medicentro",
            street: "Praça Francisco Escobar",
            number: "201",
            complement: "Sala 5, ",
            district: "Centro",
            state: "MG",
            zipCode: "37701-027",
            phones: [
              { rawNumber: "+553537216820", formatNumber: "(35) 3721-6820" },
              { rawNumber: "+5535999858799", formatNumber: "(35) 9 9985-8799" },
              { rawNumber: "+5535999350624", formatNumber: "(35) 9 9935-0624" }
            ],
            lat: -21.7809352,
            lng: -46.5680774,
            zoom: 15,
            whatsAppNumber: "5535999858799"
          }
        };
        break;

      default:
        this.profile = {
          description: [
            "Sou mineira, nascida na cidade de Poços de Caldas, cresci e me formei em Alfenas, ambas cidades do sul de Minas. Me mudei para Botucatu em em 2019 e me encantei pela cidade dos bons ares.",
            "Sou especialista em Clínica Médica pelo Hospital Universitário Alzira Vellano e Especialista em Pneumologia pela Unesp - Faculdade de Medicina de Botucatu.",
            "Atualmente realizo mais uma especialização, um fellowshipp em Medicina do sono pela Unesp - Faculdade de Medicina de Botucatu. Saiba mais sobre minha formação, publicações e trabalhos apresentados acessando meu curriculum."
          ],
          crm: "CRM SP 203777",
          address: {
            city: "São João da Boa Vista",
            rawCity: "sao-joao-da-boa-vista",
            clinic: "Espaço Vida",
            street: "Av. João Batista Bernardes",
            number: "1071",
            complement: "Sala 3",
            district: "Jardim Santo André",
            state: "SP",
            zipCode: "13874-037",
            phones: [
              { rawNumber: "+5519998743923", formatNumber: "(19) 9 9874-3923" }
            ],
            lat: -21.9694035,
            lng: -46.7869329,
            zoom: 15,
            whatsAppNumber: "5519998743923"
          }
        };
        break;

    }

    return this.profile;
  }

}
